"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

export const sobQuizInputs = [
  {
    name: "uuid",
    type: "string",
    defaultValue: "",
    hideFromUI: true,
  },
  {
    name: "questions",
    type: "reference",
    required: true,
    model: "sob-questions",
  },
  {
    name: "type",
    type: "string",
    defaultValue: "SOURCE_OF_BUSINESS",
    hideFromUI: true,
  },
  {
    name: "questionScreen",
    type: "object",
    required: true,
    defaultValue: {
      title: "Question Screen",
      description: "Question Screen description",
    },
    subFields: [
      {
        name: "title",
        type: "string",
        required: true,
      },
      {
        name: "description",
        type: "string",
        required: true,
      },
    ],
  },
  {
    name: "consentCaptureQuestion",
    type: "object",
    required: true,
    defaultValue: {
      marketingMailConsentId: "",
      title: "We'd love to send you some simple guidance to help you get familiar with Ploom.",
      description: "You'll receive how-to guides, tips, and information about Ploom Club rewards.",
    },
    subFields: [
      {
        name: "marketingMailConsentId",
        type: "string",
        required: true,
      },
      {
        name: "title",
        type: "string",
        required: true,
      },
      {
        name: "description",
        type: "string",
        required: true,
      },
    ],
  },
  {
    name: "finalScreen",
    type: "object",
    required: true,
    defaultValue: {
      title: "Tell us about yourself",
      description:
        "This will help improve your Ploom experience and ensure that you only receive content that's most relevant to you.",
    },
    subFields: [
      {
        name: "title",
        type: "string",
        required: true,
      },
      {
        name: "description",
        type: "string",
        required: true,
      },
    ],
  },
] as const satisfies Inputs;

export const SobQuizComponent: RegisteredComponent = {
  name: "SobQuiz",
  component: dynamic(async () => (await import("./SobQuiz")).SobQuiz),
  inputs: sobQuizInputs,
};
